import axios from "axios";
import { getAuthHeader, getUploadFileHeader } from "../utils";

export const addPropertyReturn = (model) => {
  const url = `${process.env.REACT_APP_BASE_URL}property-return/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.message);
    }
  );
};

export const updatePropertyReturn = (model) => {
  const url = `${process.env.REACT_APP_BASE_URL}property-return/update`;
  return axios.post(url, model, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.message);
    }
  );
};

export const getPropertyReturnList = () => {
  const url = `${process.env.REACT_APP_BASE_URL}property-return/list`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.message);
    }
  );
};

export const getPropertyReturnListForHr = (model) => {
  const url = `${process.env.REACT_APP_BASE_URL}hr-property-return/list`;
  return axios.post(url, model ,getAuthHeader()).then(
    (response) => response.data,
    (error) => {
      alert(error.message);
      return Promise.reject(error);
    }
  );
};

export const updatePropertyReturnStatus = (payload) => {
  const url = `${process.env.REACT_APP_BASE_URL}hr-property-return/update-status`;
  return axios.post(url, payload, getAuthHeader()).then(
    (response) => response.data,
    (error) => {
      alert(error.message);
      return Promise.reject(error);
    }
  );
};
